module.exports = __webpack_public_path__ + "img/sg.0e7c0640.svg";